/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Password_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Enter your password" |
*
* @param {Login_Password_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_password_placeholder = /** @type {((inputs?: Login_Password_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Password_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Entrez votre mot de passe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie Ihr Passwort ein")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci la tua password")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Введите свой пароль")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ingrese su contraseña")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请输入您的密码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("パスワードを入力してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपना कूटशब्द भरें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Digite sua senha")
	return /** @type {LocalizedString} */ ("Enter your password")
});